var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.82 6.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#606060;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.61,4.89c-.44,.95-1.22,1.28-1.74,1.38,.12-.08,.24-.19,.32-.38,.18-.39,0-.81-.13-1.01-.02-.03-.06-.02-.09,0-.04,.06-.1,.13-.18,.19,0,0,.07-.45-.45-.92-.03-.02-.07,0-.07,.03,0,.05,0,.12-.03,.17-.04,.12-.15,.32-.3,.48-.16,.17-.42,.52-.39,.79,.02,.22,.13,.49,.38,.65C.59,6.06,.07,4.97,0,4.16c-.08-.76,.64-1.75,1.09-2.22,.43-.45,.74-1,.85-1.34,.05-.16,.08-.34,.08-.49,0-.1,.12-.15,.2-.09,1.48,1.33,1.27,2.58,1.27,2.58,.22-.16,.4-.36,.5-.52,.06-.09,.18-.12,.24-.03,.36,.56,.88,1.72,.38,2.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperset);
export default __webpack_public_path__ + "static/media/SUPERSET.35d719e668de23d1da9435f0cc8999ee.svg";
export { ForwardRef as ReactComponent };